<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2>Offer Eco System (Facilitated)</h2>
      </v-col>
      <v-col cols="12">
        <v-btn :to="`/users/project/${$route.params.id}/offer-ecosystem-facilitated/create`" light color="amber"
          class="mt-5 mb-5">Add option</v-btn></v-col>
      <v-col cols="4" v-for="item in orderedItems" :key="item.id">
        <v-card light height="100%">
          <v-card-title>
            <h3 class="title" v-if="item.doc.title">{{ item.doc.title }}</h3>
            <h3 class="title" v-else>{{ item.id }}</h3>
          </v-card-title>

          <v-card-actions>
            <v-btn light color="amber" class="mb-2" @click="editCard(item.id)">View</v-btn>
            <v-btn light color="amber" class="mb-2" @click="cloneCard(item)">Clone</v-btn>
            <v-btn light color="amber" class="mb-2" @click="deleteRequest(item.id)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <bottom-navigation :save="false" :next="false" :prev="false" :list="`offer-ecosystem-facilitated`" :gridView="false"
      :gridToggle="false">
    </bottom-navigation>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete this?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="deleteItem">
            Delete
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import router from "@/router";

export default {
  name: "UserOfferSystemFacilitatedMenu",
  data() {
    return {
      items: [],
      cardId: null,
      dialog: false,
      collection: fb.offerSystemExCollection,
      returnRoute: "UserOfferSystemFacilitatedMenu",
    };
  },
  components: {
    BottomNavigation,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    orderedItems() {
      return this.items ? lodash.orderBy(this.items, "doc.title", "asc") : [];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.collection
        .where("pid", "==", this.$route.params.id)
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    closeDialog() {
      this.cardId = null;
      this.dialog = false;
    },
    deleteRequest(id) {
      this.cardId = id;
      this.dialog = true;
    },
    deleteItem() {
      this.collection
        .doc(this.cardId)
        .delete()
        .then(() => {
          this.dialog = false;
          this.cardId = null;
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    editCard(id) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/offer-ecosystem-facilitated/${id}`
      );
    },
    async cloneCard(item) {
      try {
        const originalEid = item.id;
        const pid = this.currentProjectModel.id;

        // Deep clone the exercise doc so nested structures aren't shared
        const clonedDoc = lodash.cloneDeep(item.doc || {});
        clonedDoc.title = `${item.doc && item.doc.title ? item.doc.title : ""} (copy)`;

        // Reserve the new exercise id up front so child cards can reference it
        const ref = this.collection.doc();
        const newEid = ref.id;

        // Child cards live in a separate collection keyed by eid — clone them
        // into the new exercise and build an old -> new id map.
        const idMap = {};
        if (originalEid) {
          const cardsSnap = await fb.db
            .collection("offerSystemExCollectionCards")
            .where("pid", "==", pid)
            .where("eid", "==", originalEid)
            .get();

          const batch = fb.db.batch();
          cardsSnap.forEach((cardDoc) => {
            const cardData = cardDoc.data();
            delete cardData.id;
            const newCardRef = fb.db
              .collection("offerSystemExCollectionCards")
              .doc();
            idMap[cardDoc.id] = newCardRef.id;
            batch.set(newCardRef, {
              ...cardData,
              pid: pid,
              eid: newEid,
              updatedAt: new Date(),
              createdAt: new Date(),
            });
          });
          await batch.commit();
        }

        // Remap the card ids referenced in the layout tree to the new cards
        clonedDoc.list = this.remapLayout(clonedDoc.list, idMap);

        await ref.set({
          updatedOn: new Date(),
          id: newEid,
          uid: this.currentUser.uid,
          pid: pid,
          doc: clonedDoc,
        });

        console.log("saved item");
      } catch (error) {
        alert("Error cloning document: " + error);
      }
    },
    remapLayout(list, idMap) {
      if (!Array.isArray(list)) return [];

      const remapNodes = (nodes) => {
        if (!Array.isArray(nodes)) return [];
        return nodes
          .map((node) => {
            if (!node || !node.id) return null;
            const newId = idMap[node.id];
            // Drop layout references to cards that weren't cloned
            if (!newId) return null;
            return { id: newId, children: remapNodes(node.children) };
          })
          .filter(Boolean);
      };

      return list.map((group) => ({
        ...group,
        children: remapNodes(group.children || []),
      }));
    },
  },
};
</script>

<style lang="scss"></style>
